import type {
    ApplicationFormProgressState as ApplicationFormProgressStateV2,
    PersonalInfo as PersonalInfoV2,
} from '../v2/ApplicationFormProgressState';
import { Payer as PayerV2 } from '../v2/ApplicationFormProgressState';
import { assertNever } from '~/Partials/Utils/typeUtils';
import { Payer as PayerV4 } from './ApplicationFormProgressState';
import type { ApplicationFormProgressState as ApplicationFormProgressStateV4 } from './ApplicationFormProgressState';

const mapPayer = (payer: PayerV2): PayerV4 => {
    switch (payer) {
        case PayerV2.Self:
            return PayerV4.Self;
        case PayerV2.Other:
            return PayerV4.Other;
        default:
            assertNever(payer);
    }
};

export const map = (
    progressState: ApplicationFormProgressStateV2,
    personalInfo: PersonalInfoV2 | undefined
): ApplicationFormProgressStateV4 => {
    const { order } = progressState;
    const invoice = progressState.order &&
        order.invoice && {
            ...order.invoice,
            payer: mapPayer(order.invoice.payer ?? PayerV2.Self),
        };

    return {
        ...progressState,
        version: 'v4',
        order: {
            ...order,
            orderedSubjectItems:
                progressState.order.orderedSubjectItems?.map(item => ({
                    ...item,
                    subject: {
                        ...item.subject,
                        educationCategories: [],
                    },
                })) ?? [],
            personalInfo,
            invoice,
        },
    };
};
